"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createValidator = createValidator;
exports.requiredValidator = requiredValidator;
exports.regexValidator = regexValidator;
exports.emailValidator = emailValidator;
exports.minValidator = minValidator;
exports.maxValidator = maxValidator;
exports.minLenValidator = minLenValidator;
exports.maxLenValidator = maxLenValidator;
exports.isReadonlyInput = isReadonlyInput;
exports.canHaveErrors = canHaveErrors;
exports.showErrors = showErrors;
exports.getInputErrors = getInputErrors;
exports.getFormErrors = getFormErrors;
exports.getFormArrayErrors = getFormArrayErrors;
exports.getFormGroupErrors = getFormGroupErrors;
exports.ValidatorType = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _regexpSerializer = require("@blue/services/utils/regexp-serializer");

var _itemFactory = require("./render/items/item-engine/item-factory");

var _bmFormValues = require("./render/bm-form-values");

var _utils = require("../utils");

var ValidatorType;
exports.ValidatorType = ValidatorType;

(function (ValidatorType) {
  ValidatorType["required"] = "required";
  ValidatorType["email"] = "email";
  ValidatorType["regex"] = "regex";
  ValidatorType["min"] = "min";
  ValidatorType["max"] = "max";
  ValidatorType["minLen"] = "minLen";
  ValidatorType["maxLen"] = "maxLen";
})(ValidatorType || (exports.ValidatorType = ValidatorType = {}));

var validatorTypeMap = new _map.default([[ValidatorType.required, requiredValidator], [ValidatorType.regex, regexValidator], [ValidatorType.email, emailValidator], [ValidatorType.min, minValidator], [ValidatorType.max, maxValidator], [ValidatorType.minLen, minLenValidator], [ValidatorType.maxLen, maxLenValidator]]);

function createValidator(info) {
  return {
    type: info.type,
    validate: validatorTypeMap.get(info.type)(info)
  };
}

function validateValueExists(field) {
  var exists = field.value !== '' && field.value !== null && field.value !== undefined;
  return exists;
}

function requiredValidator(_ref) {
  var errorMessage = _ref.errorMessage;
  return function (field) {
    var valid = validateValueExists(field);
    var errorMsg = errorMessage || "".concat(_fieldLabel(field), " is required");
    return valid ? null : errorMsg;
  };
}

function regexValidator(_ref2) {
  var regex = _ref2.regex,
      errorMessage = _ref2.errorMessage;

  var _regex = (0, _regexpSerializer.deserialize)(regex);

  return function (field) {
    var exists = validateValueExists(field);

    if (exists) {
      if (typeof field.value !== 'string') {
        throw new TypeError('Regex must validate strings');
      }
    }

    var valid = !exists || _regex.test(field.value);

    return valid ? null : errorMessage || "".concat(_fieldLabel(field), " is not valid");
  };
}

var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

function emailValidator(_ref3) {
  var errorMessage = _ref3.errorMessage;
  return function (field) {
    var errorMsg = errorMessage || "".concat(_fieldLabel(field), " must be a valid email");
    var regexValidatorFn = regexValidator({
      regex: (0, _regexpSerializer.serialize)(EMAIL_REGEXP),
      errorMessage: errorMsg,
      type: ValidatorType.regex
    });
    return regexValidatorFn(field);
  };
}

function minValidator(_ref4) {
  var min = _ref4.min,
      errorMessage = _ref4.errorMessage;
  return function (field) {
    var _context;

    var exists = validateValueExists(field);

    if (exists) {
      if (typeof field.value !== 'number') {
        throw new TypeError('Min must validate numbers');
      }
    }

    var valid = !exists || field.value >= min;
    return valid ? null : errorMessage || (0, _concat.default)(_context = "".concat(_fieldLabel(field), " must be at least ")).call(_context, min);
  };
}

function maxValidator(_ref5) {
  var max = _ref5.max,
      errorMessage = _ref5.errorMessage;
  return function (field) {
    var _context2;

    var exists = validateValueExists(field);

    if (exists) {
      if (typeof field.value !== 'number') {
        throw new TypeError('Max must validate numbers');
      }
    }

    var valid = !exists || field.value <= max;
    return valid ? null : errorMessage || (0, _concat.default)(_context2 = "".concat(_fieldLabel(field), " must be at most ")).call(_context2, max);
  };
}

function minLenValidator(_ref6) {
  var minLen = _ref6.minLen,
      errorMessage = _ref6.errorMessage;
  return function (field) {
    var _context3;

    var exists = validateValueExists(field);

    if (exists) {
      if (typeof field.value !== 'string') {
        throw new TypeError('MinLen must validate strings');
      }
    }

    var valid = !exists || field.value.length >= minLen;
    return valid ? null : errorMessage || (0, _concat.default)(_context3 = "".concat(_fieldLabel(field), " must be at least ")).call(_context3, minLen, " characters");
  };
}

function maxLenValidator(_ref7) {
  var maxLen = _ref7.maxLen,
      errorMessage = _ref7.errorMessage;
  return function (field) {
    var _context4;

    var exists = validateValueExists(field);

    if (exists) {
      if (typeof field.value !== 'string') {
        throw new TypeError('MaxLen must validate strings');
      }
    }

    var valid = !exists || field.value.length <= maxLen;
    return valid ? null : errorMessage || (0, _concat.default)(_context4 = "".concat(_fieldLabel(field), " must be at most ")).call(_context4, maxLen, " characters");
  };
}

function _fieldLabel(field) {
  var _field$options;

  if ((_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.label) {
    if (typeof field.options.label === 'string') {
      return field.options.label;
    }

    if (field.options.label.validationLabel) {
      return field.options.label.validationLabel;
    }

    if (field.options.label.label) {
      return field.options.label.label;
    }
  }

  return 'This field';
}

function isReadonlyInput(inputInfo) {
  return Boolean(inputInfo.readonly);
}

function canHaveErrors(inputInfo) {
  return (0, _itemFactory.isDisplayed)(inputInfo) && !inputInfo.disabled && !isReadonlyInput(inputInfo);
}

function showErrors(inputInfo) {
  var touched = inputInfo.touched;
  var show = touched;
  return show;
}

function getInputErrors(inputInfo) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref8$validatorInfos = _ref8.validatorInfos,
      validatorInfos = _ref8$validatorInfos === void 0 ? inputInfo.options.validators || [] : _ref8$validatorInfos,
      _ref8$displayedErrors = _ref8.displayedErrors,
      displayedErrors = _ref8$displayedErrors === void 0 ? true : _ref8$displayedErrors,
      _ref8$shortCircuit = _ref8.shortCircuit,
      shortCircuit = _ref8$shortCircuit === void 0 ? false : _ref8$shortCircuit;

  var emptyValidators = validatorInfos.length === 0;

  if (canHaveErrors(inputInfo) && !emptyValidators && (!displayedErrors || showErrors(inputInfo))) {
    var errors = [];

    var _iterator = (0, _createForOfIteratorHelper2.default)(validatorInfos),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var validatorInfo = _step.value;
        var validator = createValidator(validatorInfo);
        var error = validator.validate(inputInfo);

        if (error) {
          errors.push(error);

          if (shortCircuit) {
            break;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return errors.length > 0 ? errors : undefined;
  }

  return undefined;
}

function getFormErrors(item) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref9$_getInputErrors = _ref9._getInputErrors,
      _getInputErrors = _ref9$_getInputErrors === void 0 ? getInputErrors : _ref9$_getInputErrors,
      _ref9$shortCircuit = _ref9.shortCircuit,
      shortCircuit = _ref9$shortCircuit === void 0 ? false : _ref9$shortCircuit;

  if (!(0, _bmFormValues.isValuedItem)(item)) {
    return undefined;
  }

  if ((0, _bmFormValues.isAggregateItem)(item)) {
    if (!(0, _itemFactory.isDisplayed)(item)) return undefined;

    if ((0, _bmFormValues.hasbmValuedArrayMixin)(item)) {
      return getFormArrayErrors(item, {
        _getInputErrors: _getInputErrors,
        shortCircuit: shortCircuit
      });
    }

    return getFormGroupErrors(item, {
      _getInputErrors: _getInputErrors,
      shortCircuit: shortCircuit
    });
  }

  return _getInputErrors(item);
}

function getFormArrayErrors(item, opts) {
  var formArrayErrors = [];
  var children = (0, _entries.default)(item.options.items);

  var _iterator2 = (0, _createForOfIteratorHelper2.default)(children),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = (0, _slicedToArray2.default)(_step2.value, 2),
          child = _step2$value[1];

      var _childErrors = void 0;

      if ((0, _bmFormValues.isEmptyForm)(child)) {
        _childErrors = undefined;
      } else {
        _childErrors = getFormErrors(child, opts);
      }

      var invalidChild = Boolean(_childErrors);
      var childErrors = _childErrors || {};
      formArrayErrors.push(invalidChild ? childErrors : {});

      if (invalidChild && opts.shortCircuit) {
        break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _formArrayErrors = checkEmptyErrorsArray(formArrayErrors);

  return _formArrayErrors;
}

function checkEmptyErrorsArray(arr) {
  var filteredArr = (0, _filter.default)(arr).call(arr, function (i) {
    return (0, _utils.isDefined)(i) && !(0, _utils.isEmptyObj)(i);
  });
  return filteredArr.length > 0 ? arr : undefined;
}

function getFormGroupErrors(item, opts) {
  var formErrors = {};
  var children = (0, _entries.default)(item.options.items);

  var _iterator3 = (0, _createForOfIteratorHelper2.default)(children),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = (0, _slicedToArray2.default)(_step3.value, 2),
          name = _step3$value[0],
          child = _step3$value[1];

      var childErrors = getFormErrors(child, opts);

      if (childErrors) {
        formErrors[name] = childErrors;

        if (opts.shortCircuit) {
          break;
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return (0, _bmFormValues.checkEmptyObj)(formErrors);
}
